const projectModal = (() => {

  const pageProject = document.getElementById('pageProject');
  if (pageProject) {

    let sW = window.innerWidth;
    if (sW > 750) {

      MicroModal.init({
        disableScroll: true, //モーダルが開いている間、ページのスクロールが無効になります
        awaitOpenAnimation: true, //CSSアニメーションを使ってモーダルを開くか開かないかを指定
        awaitCloseAnimation: true //CSSアニメーションを使ってモーダルを閉じるか閉じないかを指定
      });

    }
  }
})();
export default projectModal;